<template>
    <div class="logs">
        <h2 class="heading-tertiary">Log Erreurs</h2>
        <h3 v-on:click="pimExoperaVisible = !pimExoperaVisible">Export PIM vers Exopera ({{ pimExoperaList.length }} fichiers)</h3>
        <DetailLog :logList="pimExoperaList" v-show="pimExoperaVisible"></DetailLog>
        <h3 v-on:click="y2PimVisible = !y2PimVisible">Import Y2 vers PIM ({{ y2PimList.length }} fichiers)</h3>
        <DetailLog :logList="y2PimList" v-show="y2PimVisible"></DetailLog>
    </div>
</template>
<script>
import { HTTP_CLIENT } from '@/axios-wrapper'
import DetailLog from '@/components/logs/DetailLog'
export default {
  data: function () {
    return {
      y2PimList: [],
      y2PimVisible: false,
      pimExoperaList: [],
      pimExoperaVisible: false
    }
  },
  components: {
    DetailLog
  },
  mounted: function () {
    this.getLogs()
  },
  methods: {
    getLogs () {
      HTTP_CLIENT
        .get(`errordetection/gety2pimrejected`)
        .then(response => {
          this.y2PimList = response.data.fichiers
          //console.log(response.data.fichiers)
        })
        .catch(error => {
          console.log(error)
        })

      HTTP_CLIENT
        .get(`errordetection/getpimexoperarejected`)
        .then(response => {
          this.pimExoperaList = response.data.fichiers
          //console.log(response.data.fichiers)
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="scss">
</style>
